import React, { useContext, useEffect, useRef, useState } from 'react';
import Input from './Input';
import { useDispatch, useSelector } from 'react-redux';
import { setEditSection, setVideo, setVideoPostMenu } from '../../../../../Features/lensSlice';
import Bucket from '../../../../../Assets/Lens/Bucket.svg';
import Play from '../../../../../Assets/Lens/Play.svg';
import Pause from '../../../../../Assets/Lens/Pause.svg';
import SoundFull from '../../../../../Assets/Lens/RadioIcon.svg';
import SoundMute from '../../../../../Assets/Lens/RadioMute.svg';
import VideoSettings from './VideoSettings';
import { VideoContext } from '../../../../../Context/VideoContext';

import { fetchFile } from '@ffmpeg/util';
import { FFmpeg } from '@ffmpeg/ffmpeg';

import { showToast } from '../../../../../Components/Toaster/Toaster';

//Store the ffmpeg instance
let ffmpeg;

function VideoPost() {
    const dispatch = useDispatch();
    const containerRef = useRef(null);
    const video = useSelector((state) => state.lens.media.video);

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    const [controlsVisible, setControlsVisible] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);

    const {
        videoFile,
        videoRef,
        setVideoFile,
        isPlaying,
        setIsPlaying,
        isMuted,
        setIsMuted,
        originalAudioUrl,
        setOriginalAudioUrl,
        setSelectedAudio,
        setLoading,
    } = useContext(VideoContext);

    // const [textTop, setTextTop] = useState(0);
    // const [textWidth, setWidth] = useState(0);

    const deleteVideo = () => {
        dispatch(setVideo(null));
        setVideoFile({});
        setOriginalAudioUrl('');
        setIsPlaying(false);
        setIsMuted(false);
        setSelectedAudio({});
        dispatch(setEditSection(null));
        dispatch(setVideoPostMenu('edit'));
        setLoading(false);
    };

    const playVideo = () => {
        videoRef.current.play();
        setIsPlaying(true);
    };

    const pauseVideo = () => {
        videoRef.current.pause();
        setIsPlaying(false);
    };

    // Toggle Audio Function
    const toggleAudio = async () => {
        if(!isMuted) {
            // Remove the audio and store the audio in original Audio state
            if (isScriptLoaded) {
                try {
                    const audioData = await fetch(originalAudioUrl).then(r => r.blob());
                    const videoData = await fetchFile(videoFile);

                    await ffmpeg.writeFile('audio.mp3', await fetchFile(audioData));
                    await ffmpeg.writeFile('video.mp4', videoData);

                    // Extract existing audio from the video
                    const extractedAudio = await ffmpeg.exec(['-i', 'video.mp4', '-q:a', '0', '-map', 'a', 'extracted_audio.mp3']);
                    // extractedAudio returns 0 or 1

                    // Save the extracted audio
                    if(!Boolean(extractedAudio)) {
                        const extractedAudioData = await ffmpeg.readFile('extracted_audio.mp3');
                        const extractedAudioBlob = new Blob([extractedAudioData.buffer], { type: 'audio/mp3' });
                        const extractedAudioUrl = URL.createObjectURL(extractedAudioBlob);
                        setOriginalAudioUrl(extractedAudioUrl);
                        setIsMuted(true);
                    }
                    else {
                        showToast('Video doesn\'t have any sound.', 'warning');
                    }

                    // Video with no audio
                    await ffmpeg.exec(['-i', 'video.mp4', '-c:v', 'copy', '-an', 'video_no_audio.mp4']);
                    const data = await ffmpeg.readFile('video_no_audio.mp4');
                    const videoBlob = new Blob([data.buffer], { type: 'video/mp4' });
                    const url = URL.createObjectURL(videoBlob);

                    const fileName = 'output.mp4';
                    const file = new File([videoBlob], fileName, { type: 'video/mp4' });
                    setVideoFile(file);
                    dispatch(setVideo({
                        id: video.id,
                        url: url,
                    }));
                    showToast('Audio muted', 'success');
                }
                catch(err) {
                    console.log(err);
                }
            }
        }
        else {
            // Add the originalAudio state back to the video
            if(isScriptLoaded) {
                if (!originalAudioUrl || !videoFile) {
                    alert('Both audio and video are required.');
                    return;
                }

                const audioData = await fetch(originalAudioUrl).then(r => r.blob());
                const videoData = await fetchFile(videoFile);

                await ffmpeg.writeFile('audio.mp3', await fetchFile(audioData));
                await ffmpeg.writeFile('video.mp4', videoData);

                // Remove existing audio from the video
                await ffmpeg.exec(['-i', 'video.mp4', '-c:v', 'copy', '-an', 'video_no_audio.mp4']);

                // Merge the audio with the video
                await ffmpeg.exec(['-i', 'video_no_audio.mp4', '-i', 'audio.mp3', '-c:v', 'copy', '-c:a', 'aac', '-shortest', 'output.mp4']);

                const data = await ffmpeg.readFile('output.mp4');
                const mergedBlob = new Blob([data.buffer], { type: 'video/mp4' });
                const url = URL.createObjectURL(mergedBlob);

                const fileName = 'output.mp4';
                const mergedFile = new File([mergedBlob], fileName, { type: 'video/mp4' });
                setVideoFile(mergedFile);
                dispatch(setVideo({
                    id: video.id,
                    url: url,
                }));
                showToast('Audio unmuted', 'success');
            }
            setIsMuted(false);
        }
    };

    useEffect(() => {
        const loadffmpeg = async () => {
            ffmpeg = new FFmpeg();
            await ffmpeg.load({ log: true });
            setIsScriptLoaded(true);
        }

        loadffmpeg();
    }, []);

    // To get the initial position of Text

    // useEffect(() => {
    //     if (videoRef.current) {
    //         const handleVideoLoad = () => {
    //             const rect = videoRef.current.getBoundingClientRect();
    //             const container = containerRef.current.getBoundingClientRect();
    //             setTextTop(parseInt((rect.top - container.top) + (rect.bottom - rect.top)/4));
    //             setWidth(parseInt((rect.right - rect.left)/2))
    //         };
    //         handleVideoLoad();
    //         console.log('New video', videoRef.current);
    //     }
    // }, [videoRef]);

    useEffect(() => {
        const handleMouseEnter = () => setControlsVisible(true);
        const handleMouseLeave = () => setControlsVisible(false);

        const containerElement = containerRef.current;

        if (containerElement) {
            containerElement.addEventListener('mouseenter', handleMouseEnter);
            containerElement.addEventListener('mouseleave', handleMouseLeave);

            return () => {
                containerElement.removeEventListener('mouseenter', handleMouseEnter);
                containerElement.removeEventListener('mouseleave', handleMouseLeave);
            };
        }
    }, []);

    // Get Video Duration
    useEffect(() => {
        if (video) {
            const videoElement = document.createElement('video');
            videoElement.src = video.url;
      
            const handleLoadedMetadata = () => {
                setDuration(videoElement.duration);
            };
      
            videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
      
            return () => {
                videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            };
        }
    }, [video]);

    // Track video current time
    useEffect(() => {
        const videoElement = videoRef.current;

        if (videoElement) {
            const handleTimeUpdate = () => {
                setCurrentTime(videoElement.currentTime);
            };

            videoElement.addEventListener("timeupdate", handleTimeUpdate);

            return () => {
                videoElement.removeEventListener("timeupdate", handleTimeUpdate);
            };
        }
    }, [videoRef, video]);

    useEffect(() => {
        const videoElement = videoRef.current;

        if(videoElement) {
            // eslint-disable-next-line eqeqeq
            if(currentTime == duration) {
                videoRef.current.currentTime = 0;
                videoRef.current.pause();
                setIsPlaying(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTime, videoRef]);

    return (
        <div className='w-3/4 max-[1280px]:w-[85%] h-[84%] flex overflow-hidden rounded-xl bg-[#FFFFFF]'>
            <div ref={containerRef} className="w-3/5 relative h-full bg-[#EAEAEA] flex items-center justify-center">
                {video ? 
                    <div className='size-full flex items-center justify-center'>
                        <video ref={videoRef} className='relative max-w-full max-h-full' src={video.url}></video>

                        {/* <p 
                            style={{
                                top: `${textTop}px`,
                                width: `${textWidth}px`
                            }} 
                            className={`absolute left-1/2 -translate-x-1/2 text-[#FFFFFF]`}>
                            Some sample text
                        </p> */}
                    </div> : 
                    <h1 className='font-normal italic text-[20px] leading-6 text-[#666666] select-none'>Video Preview</h1>
                }

                {
                    video && 
                    <>
                        <button onClick={deleteVideo} className="absolute top-4 right-4 size-8 flex items-center justify-center rounded-full bg-[#EF4444]">
                            <div className="size-[18px] flex items-center justify-center">
                                <img src={Bucket} alt="Delete" />
                            </div>
                        </button>

                        <button onClick={toggleAudio} className="absolute top-16 right-4 size-8 flex items-center justify-center rounded-full bg-[#F5F5F5]">
                            <div className="size-[18px] flex items-center justify-center">
                                {<img src={isMuted ? SoundMute : SoundFull} alt="Sound" />}
                            </div>
                        </button>
                    </>
                }

                {
                    video && 
                    <>
                        {isPlaying ? (
                            <button 
                                onClick={pauseVideo} 
                                className={`${!controlsVisible && 'opacity-0'} select-none transition-all delay-100 ease-in-out absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[50px] flex items-center justify-center`}
                            >
                                <img className='size-full' src={Pause} alt="Pause" />
                            </button>
                        ) : (
                            <button 
                                onClick={playVideo} 
                                className='select-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 size-[50px] flex items-center justify-center'
                            >
                                <img className='size-full' src={Play} alt="Play" />
                            </button>
                        )}
                    </>
                }
            </div>

            {
                video ? 
                <VideoSettings /> :
                <Input />
            }
        </div>
    );
}

export default VideoPost;
